function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 6,
  width: 22,
  height: 18,
  rx: 2,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 2H9C7.89543 2 7 2.89543 7 4V10C7 11.1046 7.89543 12 9 12H13C14.1046 12 15 11.1046 15 10V4C15 2.89543 14.1046 2 13 2ZM9 0C6.79086 0 5 1.79086 5 4V10C5 12.2091 6.79086 14 9 14H13C15.2091 14 17 12.2091 17 10V4C17 1.79086 15.2091 0 13 0H9Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 12,
  width: 2,
  height: 6,
  rx: 1,
  fill: "#C7C7C7"
});

var SvgLockedPostType = function SvgLockedPostType(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockedPostType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locked-post-type.1082298b.svg";
export { ForwardRef as ReactComponent };